import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getTargets, createProposal } from '../services/api';

const NewProposal = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const preselectedTarget = searchParams.get('target');

  const [targets, setTargets] = useState([]);
  const [selectedTarget, setSelectedTarget] = useState(preselectedTarget || '');
  const [availabilities, setAvailabilities] = useState([
    { date: '', timeSlot: '', targetConfirmed: false }
  ]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadTargets();
  }, []);

  const loadTargets = async () => {
    try {
      const response = await getTargets();
      setTargets(response.data);
    } catch (err) {
      setError('Errore nel caricamento');
    } finally {
      setLoading(false);
    }
  };

  const handleAvailabilityChange = (index, field, value) => {
    setAvailabilities(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const addAvailability = () => {
    setAvailabilities(prev => [
      ...prev,
      { date: '', timeSlot: '', targetConfirmed: false }
    ]);
  };

  const removeAvailability = (index) => {
    if (availabilities.length === 1) return;
    setAvailabilities(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!selectedTarget) {
      setError('Seleziona una persona da visitare');
      return;
    }

    const validAvailabilities = availabilities.filter(av => av.date && av.timeSlot);
    if (validAvailabilities.length === 0) {
      setError('Aggiungi almeno una disponibilita');
      return;
    }

    setSubmitting(true);
    try {
      await createProposal({
        targetId: selectedTarget,
        availabilities: validAvailabilities
      });
      navigate('/proposals/my');
    } catch (err) {
      setError(err.response?.data?.message || 'Errore nella creazione');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Caricamento...</div>;

  return (
    <div className="page-container">
      <h1>Nuova proposta di visita</h1>

      <form onSubmit={handleSubmit} className="proposal-form">
        {error && <div className="error-message">{error}</div>}

        <div className="form-group">
          <label htmlFor="target">Persona da visitare</label>
          <select
            id="target"
            value={selectedTarget}
            onChange={(e) => setSelectedTarget(e.target.value)}
            required
          >
            <option value="">Seleziona...</option>
            {targets.map((target) => (
              <option key={target._id} value={target._id}>
                {target.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-section">
          <h3>Disponibilita</h3>
          <p className="section-description">
            Indica quando sei disponibile per la visita
          </p>

          {availabilities.map((av, index) => (
            <div key={index} className="availability-row">
              <div className="form-group">
                <label>Data</label>
                <input
                  type="date"
                  value={av.date}
                  onChange={(e) => handleAvailabilityChange(index, 'date', e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Orario</label>
                <input
                  type="text"
                  placeholder="es. 17:00-19:00"
                  value={av.timeSlot}
                  onChange={(e) => handleAvailabilityChange(index, 'timeSlot', e.target.value)}
                  required
                />
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={av.targetConfirmed}
                    onChange={(e) => handleAvailabilityChange(index, 'targetConfirmed', e.target.checked)}
                  />
                  <span>Persona confermata disponibile</span>
                </label>
              </div>

              {availabilities.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeAvailability(index)}
                  className="btn btn-danger btn-small"
                >
                  Rimuovi
                </button>
              )}
            </div>
          ))}

          <button type="button" onClick={addAvailability} className="btn btn-secondary">
            + Aggiungi disponibilita
          </button>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Creazione...' : 'Crea proposta'}
          </button>
          <button type="button" onClick={() => navigate(-1)} className="btn btn-secondary">
            Annulla
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewProposal;
